import classNames from "classnames";
import { type LibraryGroup } from "@/utils/types";
import { LibrarySubGroupItem } from "./LibrarySubGroupItem";

type LibrarySubGroupViewProps = {
  title?: string;
  baseUrl: string;
  librarySubGroup: LibraryGroup;
  onGroupClick: (val: string) => unknown;
};

const listClass = classNames(
  "px-2 grid gap-12 grid-cols-1 max-w-screen-xl",
  "md:grid-cols-2 md:place-items-stretch",
  "lg:grid-cols-3 xl:grid-cols-4"
);

function _LibrarySubGroupView({
  title,
  baseUrl,
  librarySubGroup,
  onGroupClick,
}: LibrarySubGroupViewProps) {
  return (
    <div data-testid="library-sub-group-view" className="space-y-ds-5 pb-ds-4">
      {title && (
        <h3
          data-testid="library-sub-group-view-heading"
          className="font-semibold text-2xl pb-ds-2 border-b border-gray-200"
        >
          {title}
        </h3>
      )}
      <div className={listClass}>
        {Object.entries(librarySubGroup.children).map(([groupKey, group]) => {
          return (
            <LibrarySubGroupItem
              key={groupKey}
              name={groupKey}
              thumbnails={group.thumbnails.map(
                (thumbnail) => `${baseUrl}/${thumbnail}`
              )}
              onClick={onGroupClick}
            />
          );
        })}
      </div>
    </div>
  );
}

function LibrarySubGroupViewSkeleton() {
  return (
    <div data-testid="library-sub-group-view-skeleton" className={listClass}>
      {new Array(12).fill("").map((_, i) => {
        return (
          <div
            key={"placeholder" + i}
            className={
              "animate-[pulse_800ms_ease-out_infinite] w-[300px] h-[412px] -ml-8"
            }
          >
            <div className="text-gray-400 flex flex-col justify-between">
              <p className="text-sm ml-8 mb-8 whitespace-nowrap">. . .</p>
              {/* eslint-disable-next-line @next/next/no-img-element */}
              <img src="/placeholder-pdf.png" />
            </div>
          </div>
        );
      })}
    </div>
  );
}

export const LibrarySubGroupView = Object.assign(_LibrarySubGroupView, {
  Loading: LibrarySubGroupViewSkeleton,
});
